export default __webpack_public_path__ + "static/media/image_6.2fa8929e.jpg";